import { action } from "typesafe-actions";

import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { IAppForm } from "./appForm.types";
import { endPoints } from "../../constants/endPoints";
import { makeApiCall } from "../../helpers/postRequest";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { uploadFile } from "../../features/FileUpload/utils";

export const FETCH_APP_FORMS_LIST_PROGRESS = "FETCH_APP_FORMS_LIST_PROGRESS";
export const FETCH_APP_FORMS_LIST_SUCCESS = "FETCH_APP_FORMS_LIST_SUCCESS";
export const FETCH_APP_FORMS_LIST_FAILED = "FETCH_APP_FORMS_LIST_FAILED";

export const fetchAppFormListProgress = () =>
  action(FETCH_APP_FORMS_LIST_PROGRESS);
export const fetchAppFormListSuccess = (
  list: IAppForm[],
  totalRecords: number
) => action(FETCH_APP_FORMS_LIST_SUCCESS, { list, totalRecords });
export const fetchAppFormListFailed = () => action(FETCH_APP_FORMS_LIST_FAILED);

export const fetchAppFormListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAppFormListProgress());
      let finalUrl = `/other/get-apps-and-forms?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/other/get-apps-and-forms?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: IAppForm[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      dispatch(fetchAppFormListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchAppFormListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertAppFormsAysnc =
  (
    appForm: IAppForm,
    initialData: IAppForm,
    isUpdate: boolean,
    file: any | null,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const asPayload = {};
      const path = await uploadFile(
        file,
        "NOTICE",
        appForm.file || "",
        asPayload
      );
      await makeApiCall(
        {
          url: endPoints.appForms.editAppForms,
          method: "POST",
          automation: {
            isUpdate: isUpdate,
            primaryFieldName: "apps_and_forms_code",
          },
        },
        initialData,
        { ...appForm, file: path }
      );
      dispatch(
        showMessage({
          type: "success",
          message: "App from saved succesfully!",
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_APP_FORM_STATE = "CLEAR_APP_FORM_STATE";

export const clearAppFormState = () => action(CLEAR_APP_FORM_STATE);
